export const homepageFaqs = [
  {
    question:
      "What types of projects do you handle (e.g., web apps, WordPress, e-commerce, CMS)",
    answer:
      "We can handle a wide range of projects, from small to large, in a variety of technologies. Our approach is to work with you to understand your needs and then develop a technology solution that meets your requirements.",
  },
  {
    question: "What technologies do you use?",
    answer:
      "We use a variety of technologies to develop our projects. We use WordPress for most of our projects, but we can also work with you to develop a custom solution if required. If we had to name a few of the technologies that we use, they would be: HTML, CSS, JavaScript, PHP, MySQL, WordPress, React, Gatsby, Node.js, and more.",
  },
  {
    question:
      "Do you offer full-stack development or focus on front-end/back-end only?",
    answer:
      "We offer full-stack development services, but we can also work with you to develop a front-end or back-end solution as required.",
  },
  {
    question:
      "How long does it usually take to complete a web or software development project?",
    answer:
      "Smaller fixed-scope services, including WordPress fixes and suitable One-Process Automation Sprints, can often be delivered much faster than a full website or software project. Most bespoke websites and larger software projects take around two to six months, depending on scope, approvals and external dependencies. The delivery timescale is confirmed before work begins.",
  },
  {
    question: "How much does a development project typically cost?",
    answer:
      "The WordPress Fix Desk, SME Automation Sprints and White-Label WordPress packages have published fixed or starting prices. Bespoke websites, software and larger integrations are scoped and priced individually, with any third-party costs identified separately before work begins.",
  },
  {
    question: "What post-launch support packages do you offer?",
    answer:
      "We offer a range of post-launch support packages and will work with you to develop a solution that meets your requirements.",
  },
]
